
import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import LandingPage from './components/LandingPage';
import HomePage from './components/HomePage';
import GeneratorPage from './components/Generator';
import Footer from './components/Footer';

// Main Application Component


const PromptStudio = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // map pathname to our page ids
  const pathToPage = (path) => {
    if (path === '/' || path === '') return 'landing';
    if (path.startsWith('/generator')) return 'generator';
    if (path.startsWith('/home')) return 'home';
    return 'home';
  };
  const currentPage = pathToPage(location.pathname);
  const [history, setHistory] = useState([]);

  // Load history from localStorage
  useEffect(() => {
    const savedHistory = localStorage.getItem('promptHistory');
    if (savedHistory) {
      setHistory(JSON.parse(savedHistory));
    }
  }, []);

  // Save to localStorage
  const savePrompt = (prompt) => {
    const newHistory = [prompt, ...history].slice(0, 20);
    setHistory(newHistory);
    localStorage.setItem('promptHistory', JSON.stringify(newHistory));
  };

  const copyPrompt = (content) => {
    navigator.clipboard.writeText(content);
  };

  const deletePrompt = (id) => {
    const newHistory = history.filter(p => p.id !== id);
    setHistory(newHistory);
    localStorage.setItem('promptHistory', JSON.stringify(newHistory));
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
      <Navbar currentPage={currentPage} onNavigate={(pageId) => {
        // convert pageId to path
        if (pageId === 'landing') return navigate('/');
        if (pageId === 'home') return navigate('/home');
        if (pageId === 'generator') return navigate('/generator');
        return navigate('/home');
      }} />

      {/* Main Content with padding for fixed navbar (only when navbar is visible) */}
      <div className={currentPage !== 'landing' ? 'pt-16' : ''}>
        <Routes>
          <Route path="/" element={<LandingPage onStart={() => navigate('/home')} />} />
          <Route path="/home" element={<HomePage history={history} onNavigate={(pageId) => {
            if (pageId === 'generator') navigate('/generator');
            if (pageId === 'landing') navigate('/');
          }} onCopyPrompt={copyPrompt} onDeletePrompt={deletePrompt} />} />
          <Route path="/generator" element={<GeneratorPage onBack={() => navigate('/home')} onSavePrompt={savePrompt} />} />
        </Routes>
      </div>

      <Footer />

      {/* CSS Animations */}
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(100px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-fade-in {
          animation: fade-in 0.5s ease-out;
        }
        
        .animate-slide-up {
          animation: slide-up 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default PromptStudio;